export default (email) =>
  `Verification link has been sent to the new email address ${email}. Please open it to verify the new email address`;
